// 小狗图层（EP-004-S5）—— home / awaitingReveal 渲染；away 态仅离场演出期间短暂保留。
// 离场：dog-view--leaving 类驱动 CSS 动画（走向门口渐隐），onAnimationEnd 复位 store。
import { assetIndex } from '../assets/assetIndex';

interface DogViewProps {
  leaving?: boolean;
  onLeaveEnd?: () => void;
}

export function DogView({ leaving = false, onLeaveEnd }: DogViewProps) {
  return (
    <div
      className={leaving ? 'dog-view dog-view--leaving' : 'dog-view'}
      onAnimationEnd={leaving ? onLeaveEnd : undefined}
    >
      <img className="dog-view__img" src={assetIndex.dog_idle} alt="小狗" />
    </div>
  );
}
